import React from 'react';
import { GlobalBottomSheetRef } from 'src/components/GlobalBottomSheet';
class BottomSheetService {
  static instance: React.MutableRefObject<GlobalBottomSheetRef>;
}

export default BottomSheetService;
